import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { BatchGroupRow } from "../views/batchGroupsViewConfig";
import { renderCondition } from "../../rules/utils/ruleConditionFormatters";
import styles from "./BatchGroupConditionsCell.module.scss";

export const BatchGroupConditionsCell = memo(
    ({ row }: { row: { original: BatchGroupRow } }) => {
        const { ruleConditions } = row.original;
        if (!ruleConditions?.length) {
            return <ViewTableCell />;
        }

        return (
            <ViewTableCell>
                <div className={styles.list}>
                    {ruleConditions.map((condition, index) => {
                        const content = renderCondition(condition);
                        if (!content) {
                            return null;
                        }
                        return (
                            <span key={index} className={styles.item}>
                                {content}
                            </span>
                        );
                    })}
                </div>
            </ViewTableCell>
        );
    },
);
BatchGroupConditionsCell.displayName = "BatchGroupConditionsCell";
